import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "6.333",
      r: "4",
      stroke: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      d: "M2 18.463a8.286 8.286 0 0 1 16 0"
    }, null, -1)
  ]))]))
}
export default { render: render }